/* eslint-disable @typescript-eslint/no-var-requires */
const lodash = require('lodash');

// Lodash is also have "defaultsDeep" function, but it's not fully overriding arrays from default by new value,
// it's overriding changed values by index.
// For example:
// default value is ['one', 'two', 'three']
// target value is ['FOUR', 'FIVE']
// Lodash's "defaultsDeep" returns ['FOUR', 'FIVE', 'three']
// function below returns ['FOUR', 'FIVE']

const defaultsDeep = (targetObj, defaultObj) => {
  const allKeysObj = lodash.defaultsDeep(lodash.cloneDeep(targetObj), lodash.cloneDeep(defaultObj));
  const result = {};
  Object.keys(allKeysObj).forEach((key) => {
    const targetValue = targetObj?.[key];
    const defaultValue = defaultObj[key];
    if (lodash.isPlainObject(defaultValue)) {
      result[key] = defaultsDeep(targetValue, defaultValue);
    } else {
      result[key] =
        targetValue === undefined
          ? defaultValue
          : Array.isArray(targetValue)
          ? targetValue
          : typeof targetValue === 'boolean'
          ? targetValue
          : targetValue || defaultValue;
    }
  });
  return lodash.cloneDeep(result);
};

module.exports = defaultsDeep;
